/**
 * The wire error's `code`, read defensively.
 *
 * A refusal branch that keys off the code must degrade to its generic case when
 * the body does not carry one — an unparseable or non-conforming body is exactly
 * the situation in which asserting a specific cause would be a guess.
 */
export function errorCodeOf(body: unknown): string | null {
  if (typeof body !== 'object' || body === null) return null;

  const error = (body as { error?: unknown }).error;

  if (typeof error !== 'object' || error === null) return null;

  const code = (error as { code?: unknown }).code;

  return typeof code === 'string' ? code : null;
}

/**
 * The wire error's `details`, read defensively. Beside `errorCodeOf` for the
 * same reason: a refusal whose German copy is an ICU `select` on a `details`
 * key needs the placeholder, not only the code.
 */
export function errorDetailsOf(body: unknown): Record<string, unknown> | null {
  if (typeof body !== 'object' || body === null) return null;

  const error = (body as { error?: unknown }).error;

  if (typeof error !== 'object' || error === null) return null;

  const details = (error as { details?: unknown }).details;

  return typeof details === 'object' && details !== null ? (details as Record<string, unknown>) : null;
}
